import { Link } from '@tanstack/react-router';
import { FlaskConical } from 'lucide-react';

import { useGetDemoModeStatus } from '~entities/demo-mode/api/demo-mode-api';

export const DemoModeBanner = () => {
  const { data, isLoading } = useGetDemoModeStatus();

  if (isLoading || !data?.isDemoMode) {
    return null;
  }

  return (
    <div
      data-enrollio-demo-banner
      className='flex w-full min-w-0 max-w-full flex-col items-center justify-center gap-2 overflow-x-clip bg-amber-500 px-4 pt-2 pb-3 text-center text-sm font-medium text-white sm:flex-row sm:text-left'
    >
      <FlaskConical className='h-4 w-4 shrink-0' />
      <span className='min-w-0 max-w-full text-balance break-words'>
        Demo Mode is active — Stripe is using test credentials. No live charges
        will be processed.
      </span>
      <Link
        to='/demo-mode'
        className='ml-1 shrink-0 underline underline-offset-2 hover:text-amber-100'
      >
        Settings
      </Link>
    </div>
  );
};
